import { render, staticRenderFns } from "./addTags.vue?vue&type=template&id=0fac3484&scoped=true"
import script from "./addTags.vue?vue&type=script&lang=js"
export * from "./addTags.vue?vue&type=script&lang=js"
import style0 from "./addTags.vue?vue&type=style&index=0&id=0fac3484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac3484",
  null
  
)

export default component.exports